import React from 'react';
import { ChefHatIcon } from 'lucide-react';
export function Header() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-orange-100 shadow-sm" data-id="element-75">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between gap-2" data-id="element-76">
        <div className="flex items-center gap-2 min-w-0" data-id="element-77">
          <div className="bg-rose-500 p-1.5 rounded-lg text-white flex-shrink-0" data-id="element-78">
            <ChefHatIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-79" />
          </div>
          <span className="font-bold text-base sm:text-xl text-gray-800 tracking-tight truncate" data-id="element-80">
            Cocina Sin Estrés™
          </span>
        </div>

        <button onClick={scrollToPricing} className="bg-rose-500 hover:bg-rose-600 text-white px-4 sm:px-6 py-2 rounded-full text-sm sm:text-base font-bold transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5 animate-button-pulse flex items-center gap-2 flex-shrink-0" data-id="element-81">
          <span data-id="element-82">Comenzar</span>
        </button>
      </div>
    </header>;
}